<script setup lang="ts">
import type { Locale } from 'lc-services/types'

const config = useRuntimeConfig()
const { locale } = useI18n()

const props = defineProps<{
  email: string
}>()

const typeformFeedbackID = computed(() => {
  const ids = {
    fr: config.public.typeformFeedbackInquiryFR,
    en: config.public.typeformFeedbackInquiryEN,
  }

  return ids[locale.value as Locale]
})

const typeformEmail = computed(() => {
  return props.email ? `email=${props.email}` : ''
})
</script>

<template>
  <!-- Inquiry Typeform -->
  <button
    id="inquiry-typeform"
    class="hidden"
    data-tf-position="right"
    data-tf-opacity="100"
    data-tf-medium="snippet"
    :data-tf-slider="typeformFeedbackID"
    :data-tf-hidden="typeformEmail"
    type="button"
  />
</template>
